import { createFileRoute } from '@tanstack/react-router';

import {
  AnalyticsReportPage,
  analyticsEventsQueryOptions,
  analyticsSummaryQueryOptions,
  eventListParams,
  eventListSearchSchema,
} from '@/features/analytics';
import { resolveRange, todayIn } from '@/features/reports';

export const Route = createFileRoute('/_authed/_active/s/$storeId/reports/analytics')({
  staticData: { crumb: 'reports:tabs.analytics', tours: ['reports.analytics'] },
  validateSearch: eventListSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: async ({ context, params, deps, cause }) => {
    const range = resolveRange(deps, todayIn(context.store.timezone));
    const prefetch = Promise.all([
      context.queryClient
        .query({
          ...analyticsSummaryQueryOptions(params.storeId, range),
          staleTime: 'static',
        })
        .catch(() => undefined),
      context.queryClient
        .query({
          ...analyticsEventsQueryOptions(params.storeId, eventListParams(deps, range)),
          staleTime: 'static',
        })
        .catch(() => undefined),
    ]);
    // A filter or page change on the log must not wait for the fetch: the URL would lag behind,
    // and a second pick in the filter would build on the stale filters.
    if (cause !== 'stay') await prefetch;
  },
  component: AnalyticsReportPage,
});
